const homeContentEndpoints = {
  base: "/v1/cms/home-content",
};

export default homeContentEndpoints;
